import "./App.css";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useEffect, useRef } from "react";
import LocomotiveScroll from "locomotive-scroll";
import "locomotive-scroll/dist/locomotive-scroll.css";

import { Outlet, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Footer from "./components/Footer";

function App() {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (!scrollRef.current) return;

    const locoScroll = new LocomotiveScroll({
      el: scrollRef.current,
      smooth: true,
    });

    return () => {
      locoScroll.destroy();
    };
  }, []);

  // Smooth mouse tracking for background glow
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const smoothX = useSpring(mouseX, {
    stiffness: 20,
    damping: 10,
  });

  const smoothY = useSpring(mouseY, {
    stiffness: 20,
    damping: 10,
  });

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouseX.set(e.clientX - window.innerWidth / 2);
      mouseY.set(e.clientY - window.innerHeight / 2);
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [mouseX, mouseY]);

  const Wapper = () => {
    return (
      <div
        className="bg-[#020617] selection:bg-purple-500/30"
        data-scroll-container
        ref={scrollRef}
        style={{
          maxWidth: "100vw",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        {/* Background grid */}
        <div className="fixed inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" />

        {/* Mouse-following glow */}
        <motion.div
          style={{
            x: smoothX,
            y: smoothY,
          }}
          className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] h-[60vw] bg-purple-600/20 rounded-full blur-[120px] opacity-50 pointer-events-none"
        />

        {/* Child routes render here */}
        <Outlet />

        <Footer />
      </div>
    );
  };

  return (
    <Routes>
      <Route path="/" element={<Wapper />}>
        <Route index element={<Home />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<Projects />} />
        <Route path="contact" element={<div>Contact</div>} />
        <Route path="*" element={<div>404 Not Found</div>} />
      </Route>
    </Routes>
  );
}

export default App;
